/** The person's private calendar link: their actions, the milestones, and (for directors) decisions' review dates. */
import { toast } from "sonner";
import { Dialog } from "@otii/ui/overlay";
import { Button } from "@otii/ui/ui";
import { CalendarLink } from "@otii/ui/calendar-link";
import { useCalendarFeed, useResetCalendarFeed } from "../lib/queries";

export function CalendarLinkDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (v: boolean) => void }) {
  const feed = useCalendarFeed(open);
  const reset = useResetCalendarFeed();
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Google Calendar"
      footer={
        <Button variant="ghost" onClick={() => onOpenChange(false)}>
          Close
        </Button>
      }
    >
      <CalendarLink
        url={feed.data?.url ?? null}
        loading={feed.isLoading}
        error={feed.error}
        unavailable="The link works once the governance system runs on a public address."
        onReset={() => reset.mutateAsync()}
        resetting={reset.isPending}
        onCopied={(ok) => (ok ? toast.success("Link copied") : toast.error("Couldn't copy. Select the link and copy it instead."))}
      />
    </Dialog>
  );
}
